import React, { useEffect, useState } from "react";
import { Widget } from "./Widget";
import { GRAPH_TYPES } from "../../../constants/app-constant";
import {
  DATA_TYPES_OPTIONS,
  DATA_TYPES,
} from "../../../constants/static-filter";
import HorizontalTabs from "../../Shared/HorizontalTabs";
const { PIE, DOUGHNUT } = GRAPH_TYPES;
export default function EmbededFeedWidget({
  widget,
  setShowWidgetConfig,
  setEditWidgetData,
  setEmbededFeedsParams,
  inlineGraphTypeOptions,
  onWidgetDelete,
  setWidgetCreationStatus,
  fetchWidgets,
  selectedDataType,
  preSelectedWCType,
  countryWiseFeeds,
  isAnalysisReport,
  contributedWidgetFilter,
  twitterFeeds,
  insightFeeds = 0,
  keyMetrics,
  twitterMetricsData,
  twitterBreakDownLine,
  twitterBreakDownPie,
  startRange,
  endRange,
  tonality,
  topicId,
  widgetApiInProgress,
  tabData,
  fromUserName,
  setFromUserName
}) {
  const [selectedGraphType, setSelectedGraphType] = useState(widget.graph_type);
  const [selectedEmbededDataType, setSelectedEmbededDataType] = useState(
    selectedDataType || DATA_TYPES.NUMBER
  );

  useEffect(() => {
    setSelectedGraphType(widget.graph_type);
  }, [widget]);

  const defaultWidget = { ...widget, graph_type: selectedGraphType };
  return (
    <>
      <div className={`embededWidget`}>
        <Widget
          key={`embeded-widget`}
          widget={defaultWidget}
          onDelete={onWidgetDelete}
          setShowWidgetConfig={setShowWidgetConfig}
          setEditWidgetData={setEditWidgetData}
          setEmbededFeedsParams={setEmbededFeedsParams}
          isEmbededWidget
          setFromUserName = {(e) => {
            setFromUserName(e)
          }}
          fromUserName={fromUserName}
          setWidgetCreationStatus={setWidgetCreationStatus}
          fetchWidgets={fetchWidgets}
          inlineGraphTypeOptions={inlineGraphTypeOptions}
          selectedDataType={selectedEmbededDataType}
          preSelectedWCType={preSelectedWCType}
          countryWiseFeeds={countryWiseFeeds}
          isAnalysisReport={isAnalysisReport}
          contributedWidgetFilter={contributedWidgetFilter}
          twitterFeeds={twitterFeeds}
          insightFeeds={insightFeeds}
          topicId={topicId}
          startRange={startRange}
          endRange={endRange}
          tonality={tonality}
          twitterBreakDownPie={twitterBreakDownPie}
          twitterBreakDownLine={twitterBreakDownLine}
          keyMetrics={keyMetrics}
          twitterMetricsData={twitterMetricsData}
          tabData={tabData}
          widgetApiInProgress={widgetApiInProgress}
        />
      </div>
      <div className="fcTabsWrap">
        {(selectedGraphType == PIE || selectedGraphType == DOUGHNUT) && (
          <HorizontalTabs
            data={DATA_TYPES_OPTIONS}
            selectedTab={selectedEmbededDataType}
            setSelectedTab={setSelectedEmbededDataType}
            activeClass="active"
          />
        )}
        <HorizontalTabs
          data={inlineGraphTypeOptions}
          selectedTab={selectedGraphType}
          setSelectedTab={setSelectedGraphType}
          activeClass="active"
        />
      </div>
    </>
  );
}

EmbededFeedWidget.defaultProps = {
  widget: {},
  onDelete: () => {},
  setEditWidgetData: () => {},
  onWidgetDelete: () => {},
};
